import { Button, Col, Container, Row } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useForm from './useForm';
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import './style.css';
import { CircularProgress } from '@material-ui/core';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ViewBook = () => {
  const { book, bookFile, loading, error, setError } = useForm();
  const { t } = useTranslation();

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function onDocumentLoadError(error) {
    // console.log('error :', error);
    // "InvalidPDFException"
    setError('ERROR_LOADING_PDF');
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  const PageNavigation = () => {
    return (
      <div className="page-navigation">
        <p>
          Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
        </p>
        <Button theme="info" disabled={pageNumber <= 1} onClick={previousPage}>
          {t('pdf.previous')}
        </Button>
        &nbsp; &nbsp;
        <Button theme="info" disabled={pageNumber >= numPages} onClick={nextPage}>
          {t('pdf.next')}
        </Button>
      </div>
    );
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title={book.title} subtitle={t('book.subTitle')} className="text-sm-left" />
      </Row>
      <Row>
        <Col className="text-center">
          {loading === true ? (
            <CircularProgress color="inherit" style={{ marginTop: '100px', width: '100px', height: '100px' }} />
          ) : (
            <>
              <PageNavigation />

              {error !== null ? (
                <h3 className="text-danger">{t(error)}</h3>
              ) : (
                <Document
                  className="pdf-document"
                  file={bookFile}
                  onLoadError={onDocumentLoadError}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  <Page pageNumber={pageNumber} />
                </Document>
              )}

              <PageNavigation />
            </>
          )}
          {}
        </Col>
      </Row>
    </Container>
  );
};

export default ViewBook;
